import { useBlockProps, BlockControls } from '@wordpress/block-editor';
import { ToolbarGroup, ToolbarButton } from '@wordpress/components';
import { __ } from '@wordpress/i18n';

import AllInspectorControls from './InspectorControls';
import ChartFigure from '../lib/chart-figure';
import {
	normalizeConfig,
	rootClassName,
	styleVars,
} from '../lib/chart-config';
import { CHART_TYPE_OPTIONS } from './chart-types';
import {
	useReplayPreview,
	PlayPreviewControl,
} from '../../_shared/replay-preview';

import '../style.scss';
import './editor.scss';

/*
 * The reveal's longest strand: the mark keyframes run 620ms, but the value
 * labels wait 420ms before their own 500ms fade. Anything shorter would
 * release the toolbar button while the chart was still drawing.
 */
const REVEAL_DURATION = 920;

export default function Edit( { attributes, setAttributes } ) {
	const config = normalizeConfig( attributes );

	const { isPlaying, play } = useReplayPreview( REVEAL_DURATION );

	const blockProps = useBlockProps( {
		// `is-revealing` is exactly what view.js sets on the frontend, and the
		// editor imports the same stylesheet — so this plays the real reveal
		// rather than an approximation of it.
		className: `${ rootClassName( config ) }${
			isPlaying ? ' is-revealing' : ''
		}`,
		style: styleVars( config ),
	} );

	return (
		<>
			{ /*
			  * Only when the chart animates and there is something drawn to
			  * animate — the empty state is a paragraph of instructions.
			  */ }
			{ attributes.animate && config.categories.length > 0 && (
				<PlayPreviewControl isPlaying={ isPlaying } onPlay={ play } />
			) }

			<BlockControls group="block">
				<ToolbarGroup>
					{ CHART_TYPE_OPTIONS.map( ( option ) => (
						<ToolbarButton
							key={ option.value }
							icon={ option.icon }
							label={ option.label }
							isActive={ attributes.chartType === option.value }
							onClick={ () =>
								setAttributes( { chartType: option.value } )
							}
						/>
					) ) }
				</ToolbarGroup>
			</BlockControls>

			<AllInspectorControls
				attributes={ attributes }
				setAttributes={ setAttributes }
				config={ config }
			/>

			<div { ...blockProps }>
				{ config.categories.length ? (
					<ChartFigure config={ config } />
				) : (
					<p className="brandy-chart__empty">
						{ __(
							'Add at least one category in the Data panel to draw the chart.',
							'brandy-blocks'
						) }
					</p>
				) }
			</div>
		</>
	);
}
